<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Proces
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col>
                        <v-autocomplete
                            v-model="process"
                            :items="machineProcesses"
                            label="Proces"
                            return-object
                            item-text="name"
                            no-data-text="Nie znaleziono procesu"
                            outlined
                            dense
                            required
                            :error-messages="processErrors"
                        />
                    </v-col>
                </v-row>
            </div>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    @click="onSave"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'ProcessDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        machineProcesses: {
            type: Array,
            default: () => []
        },
        defaultProcess: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            process: null
        }
    },
    validations() {
        return {
            process: {
                required
            }
        }
    },
    computed: {
        processErrors() {
            const errors = []

            if (!this.$v.process.$dirty) return errors

            if (!this.$v.process.required) {
                errors.push('Proszę wybrać proces.')
            }

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.process = JSON.parse(JSON.stringify(this.defaultProcess))
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()
            if (this.$v.$invalid) return
            this.$emit('on-save', this.process)
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
            this.$v.$reset()
            this.process = null
        },
    }
}
</script>